import "src/css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect } from 'react';
import MonitorWSService from 'src/services/monitorwsservice';
import { Chart, Series, CommonSeriesSettings, Legend, ArgumentAxis, Label, Animation, Tooltip } from 'devextreme-react/chart';
import WidgetSettings from "../widgetSettings";
import { selectionTypes } from "src/components/utils/consts";
import WidgetTools from "../widgetTools";

function SentimentByGroup(props) {

    const { t } = useTranslation();
    const [groups, setGroups] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [showSettings, setShowSettings] = useState(false);
    const [channel, setChannel] = useState(localStorage.getItem(`SentimentByGroup_channel_${props.identifier}_user${props.id}`) || "");
    const [channelName, setChannelName] = useState(localStorage.getItem(`SentimentByGroup_channelName_${props.identifier}_user${props.id}`) || "");

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/analysissentimentbygroup", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("analysissentimentbygroup");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {
            let selectedGroups = JSON.parse(localStorage.getItem(`SentimentByGroup_groups_${props.identifier}_user${props.id}`) || "[]");
            let channel = localStorage.getItem(`SentimentByGroup_channel_${props.identifier}_user${props.id}`) || "";
            setSelectedGroups(selectedGroups);
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/analysissentimentbygroup/`, function (callsbygroup) {
                if (localStorage.getItem("resizing") !== "true") {
                    let data = JSON.parse(callsbygroup.body);
                    setGroups(data);
                }
            }, { id: "analysissentimentbygroup" });

            MonitorWSService.stompClient.send("/app/subscribe/analysissentimentbygroup", {}, JSON.stringify({
                token: props.token,
                groupsIds: selectedGroups,
                channel: channel
            }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const customizeTooltip = (arg) => {
        return {
            text: `${arg.seriesName}: ${arg.valueText}`,
        };
    }
    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }


    const setGroupsAndChannel = (groups, channel, channelName) => {
        setShowSettings(!showSettings);
        setSelectedGroups(groups);
        localStorage.setItem(`SentimentByGroup_groups_${props.identifier}_user${props.id}`, JSON.stringify(groups));

        setChannel(channel);
        setChannelName(channelName);
        localStorage.setItem(`SentimentByGroup_channel_${props.identifier}_user${props.id}`, channel);
        localStorage.setItem(`SentimentByGroup_channelName_${props.identifier}_user${props.id}`, channelName);

        MonitorWSService.stompClient.send("/app/subscribe/analysissentimentbygroup", {}, JSON.stringify({
            token: props.token,
            groupsIds: groups,
            channel: channel
        }));

    };



    return (

        <div className="card card-flush overflow-hidden h-lg-20 widget-container">
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("chart-simple")} /> {t("sentimentbygroup")}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools  key={`tools_${props.identifier}`}closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem", height: "100%" }}>
                <Chart
                    id="chart"
                    dataSource={groups}
                    height={"345px"}
                    rtlEnabled={props.rtl}

                >
                    <CommonSeriesSettings aggregatedPointsPosition="crossTicks" argumentField="name" type="stackedBar" barWidth={20} />
                    <Series
                        valueField="negative"
                        name={t("negative")}
                        color={"#f1416c"}
                    />
                    <Series
                        valueField="positive"
                        name={t("positive")}
                        color={"#50cd89"}

                    />

                    <Series
                        valueField="neutral"
                        name={t("neutral")}
                        color={"#b2b3bb"}
                    />
                    <ArgumentAxis>
                        <Label
                            wordWrap="none"
                            overlappingBehavior={"rotate"}
                            rotationAngle={35}
                        />
                    </ArgumentAxis>
                    <Legend
                        verticalAlignment="bottom"
                        horizontalAlignment="center"
                        itemTextPosition="top"
                    />
                    <Animation
                        enabled={false}
                    />
                    <Tooltip
                        enabled={true}
                        location="edge"
                        customizeTooltip={customizeTooltip}
                    />
                </Chart>
            </div>
            <WidgetSettings key={`settings_${props.identifier}`}showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroupsAndChannel={setGroupsAndChannel} groups={selectedGroups} selectionType={selectionTypes.MESSAGESQUEUE} channel={channel} channelName={channelName}></WidgetSettings>
        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(SentimentByGroup);